import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ProjectInformationModal({ open, onClose, project }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#0258DA' }}>
          {project?.name}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {project?.information ? (
          <Box
            sx={{
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                marginTop: 2,
                marginBottom: 1,
                fontWeight: 'bold',
              },
              '& h1': { fontSize: '2rem' },
              '& h2': { fontSize: '1.75rem' },
              '& h3': { fontSize: '1.5rem' },
              '& h4': { fontSize: '1.25rem' },
              '& h5': { fontSize: '1.1rem' },
              '& h6': { fontSize: '1rem' },
              '& p': {
                marginBottom: 1,
                lineHeight: 1.6,
              },
              '& ul': {
                listStyleType: 'disc',
                paddingLeft: 3,
                marginLeft: 2,
                marginBottom: 1,
                display: 'block',
              },
              '& ol': {
                listStyleType: 'decimal',
                paddingLeft: 3,
                marginLeft: 2,
                marginBottom: 1,
                display: 'block',
              },
              '& li': {
                display: 'list-item',
                marginBottom: 0.5,
                marginLeft: 1,
                paddingLeft: 0.5,
              },
              '& strong, & b': {
                fontWeight: 'bold',
              },
              '& em, & i': {
                fontStyle: 'italic',
              },
              '& u': {
                textDecoration: 'underline',
              },
              '& s, & strike': {
                textDecoration: 'line-through',
              },
              '& a': {
                color: '#0258DA',
                textDecoration: 'underline',
              },
              '& img': {
                maxWidth: '100%',
                height: 'auto',
                marginTop: 1,
                marginBottom: 1,
              },
              '& blockquote': {
                borderLeft: '4px solid #0258DA',
                paddingLeft: 2,
                marginLeft: 0,
                marginTop: 1,
                marginBottom: 1,
                fontStyle: 'italic',
                color: 'text.secondary',
              },
            }}
            dangerouslySetInnerHTML={{ __html: project.information }}
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            No additional information available for this project.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

